// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const ReviewTransferRequestDealer = t.struct({
    id: t.String,
    pin: t.String
}, {
    name: 'ReviewTransferRequestDealer',
    strict: true
});

export const getDefaultState = () => new ReviewTransferRequestDealer({
    id: '',
    pin: ''
});

export default ReviewTransferRequestDealer;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/review-transfer-request.js